'use strict';

import _ from 'lodash';
import move from 'lodash-move';
import React from 'react';
import Listing from '../common/listing';
import Sponsor from '../common/sponsor';
import Analytics from '../common/analytics';

class Sponsors extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let levels = _(this.props.conference.current.sponsors)
      .reject((sponsor) => { return sponsor.level === 'exhibitor' })
      .sortBy((sponsor) => { return ['lead-sponsor', 'co-sponsor', 'diamond', 'platinum', 'gold', 'summit-sponsors', 'co-host-summit-sponsor', 'strategic-partnership-sponsor', 'strategic-partner', 'track-sponsors', 'marketing-sponsors', 'exhibition-sponsors', 'innovation-plaza-sponsor', 'ambassador', 'delegation-network', 'sponsor', 'partner', 'associate-sponsor'].indexOf(sponsor.level); })
      .map((sponsor) => { return <Sponsor key={sponsor._id} sponsor={sponsor} showLevel={true} showPhoto={true} {...this.props} /> })
      .groupBy('props.sponsor.level')
      .value();

    // Display lead sponsors before co-sponsors
    if (levels['lead-sponsor']) {
      let leadSponsorsIndex = _.indexOf(_.keysIn(levels), 'lead-sponsor');
      let coSponsorsIndex = _.indexOf(_.keysIn(levels), 'co-sponsor');
      // An array of all of the sponsor types
      let keys = _.keysIn(levels);
      if (leadSponsorsIndex > coSponsorsIndex) {
        // Move the lead sponsor array in the co-sponsor position if it is behind it
        // Lead Sponsors have to appear before co sponsors
        keys = move(keys, leadSponsorsIndex, coSponsorsIndex);
        let orderedLevels = {};
        for (var j = 0; j < keys.length; j++) {
          orderedLevels[keys[j]] = levels[keys[j]];
        }
        levels = orderedLevels;
      }
    }

    let sponsor = this.props.conference.current.sponsors ?
      this.props.conference.current.sponsors[this.props.params.sponsor_id] :
      null;

    return <div className="sponsors">
      <section className="section">
        <div className="opportunities wrap-two clearfix">
          <div className="title">Sponsors</div>
          {!sponsor ? null : <Sponsor key={sponsor._id} sponsor={sponsor} showPhoto={true} showBio={true} {...this.props} />}
          {!this.props.conference.current.become_sponsor_email || sponsor ? null :
            <a
              className="button button-green"
              href={'mailto:' + this.props.conference.current.become_sponsor_email}>Partner with us
            </a>
          }
        </div>
      </section>

      {_.map(levels, (level, k) => {
          k = k !== 'co-sponsor' ? (k !== 'co-host-summit-sponsor' ? _.replace(k,new RegExp('-','g'),' ') : 'Co-host | Summit Sponsor') : k;
        return <section key={k} className="section">
          <Listing elements={level} title={!k || k === 'sponsor' ? 'Sponsors' : k} />
        </section>
      })}

      <Analytics view="sponsors" key={!sponsor ? 1 : sponsor._id} subTier={!sponsor ? null : sponsor._id} {...this.props} />

    </div>

  }
}

export default Sponsors;
